import { getAuth } from "firebase/auth";
import { APP_VERSION } from "@/versionInfo";

const TELEMETRY_EVENT = "clipn:upload-request-error";

const getCurrentUserId = () => {
  try {
    return getAuth().currentUser?.uid || null;
  } catch (error) {
    return null;
  }
};

const buildRequestUrl = (config = {}) => {
  const baseUrl = config.baseURL || "";
  const url = config.url || "";
  if (baseUrl && url) {
    try {
      return new URL(url, baseUrl).toString();
    } catch (error) {
      return `${baseUrl}${url}`;
    }
  }
  return url || null;
};

export const captureUploadRequestErrorTelemetry = ({
  requestId,
  error,
  fallbackUrl,
}) => {
  const payload = {
    timestamp: new Date().toISOString(),
    userId: getCurrentUserId(),
    requestUrl: buildRequestUrl(error?.config) || fallbackUrl || null,
    requestId: requestId || null,
    networkError: {
      name: error?.name || null,
      message: error?.message || null,
      code: error?.code || null,
    },
    httpStatus: error?.response?.status ?? null,
    frontendVersion: APP_VERSION.version,
    commitSha: APP_VERSION.commitSha,
    buildTime: APP_VERSION.buildTime,
  };

  try {
    window.dispatchEvent(
      new CustomEvent(TELEMETRY_EVENT, {
        detail: payload,
      })
    );
  } catch (dispatchError) {
    // No-op: telemetry dispatch should never impact upload flow.
  }

  console.error("[UploadService] upload_request_error_telemetry", payload);
  return payload;
};

